export const WEEK_DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
export const FREE_SUBJECT = "__FREE__";

export function cellKey(rowKey, day) {
    return `${rowKey}|${day}`;
}

export function buildCellDraftsFromRows(rows) {
    const d = {};
    if (!Array.isArray(rows)) return d;
    for (const row of rows) {
        if (row.type === "break") continue;
        for (const day of WEEK_DAYS) {
            const c = row[day];
            if (c?.type === "lesson") {
                const key = cellKey(row.key, day);
                const isFree = Boolean(c.filler) || !String(c.subjectName || "").trim();
                d[key] = {
                    subjectName: isFree ? "" : String(c.subjectName || "").trim(),
                    subjectId: String(c.subjectId || "").trim(),
                    teacherName: String(c.teacherName || "").trim(),
                    teacherId: String(c.teacherId || "").trim(),
                    facilityId: String(c.facilityId || "").trim(),
                    roomName: String(c.roomName || c.room || "").trim(),
                };
            }
        }
    }
    return d;
}

export function displayLessonCell(row, day, baseCell, cellEdits) {
    if (!baseCell || baseCell.type !== "lesson") return baseCell;
    const key = cellKey(row.key, day);
    const draft = cellEdits[key];
    if (!draft) return baseCell;
    const subj = String(draft.subjectName || "").trim();
    return {
        ...baseCell,
        subjectName: subj || baseCell.subjectName,
        teacherName: draft.teacherName ?? baseCell.teacherName,
        teacherId: draft.teacherId ?? baseCell.teacherId,
        facilityId: draft.facilityId ?? baseCell.facilityId,
        room: draft.roomName || baseCell.room,
        roomName: draft.roomName || baseCell.roomName || baseCell.room,
    };
}

export function formatConflictSummary(conflicts) {
    if (!conflicts?.total) return "No conflicts detected.";
    const parts = [];
    if (conflicts.teacherConflicts?.length) {
        parts.push(`${conflicts.teacherConflicts.length} teacher clash(es)`);
    }
    if (conflicts.roomConflicts?.length) {
        parts.push(`${conflicts.roomConflicts.length} room clash(es)`);
    }
    if (conflicts.bookingConflicts?.length) {
        parts.push(`${conflicts.bookingConflicts.length} booking clash(es)`);
    }
    return parts.join(", ");
}
